import { useTheme } from 'styled-components'
import { Modal, ModalProps, InjectedModalProps } from 'vvs-uikit'
import { LoadingView } from './LoadingView'

type GotchiModalProps = Omit<ModalProps & InjectedModalProps, 'title'> & {
  title?: ModalProps['title']
}

export const GotchiModal: React.FC<GotchiModalProps> = ({ children, ...props }) => {
  const theme = useTheme()

  return (
    <Modal maxWidth="450px" background={theme.colors.paleYellow} titleJustifyContent="start" title={null} {...props}>
      {children}
    </Modal>
  )
}

export const RunningModal: React.FC<
  InjectedModalProps & {
    imageSrc?: string
  }
> = ({ children, imageSrc, onDismiss }) => {
  const theme = useTheme()

  return (
    <Modal title={null} onDismiss={onDismiss} background={theme.colors.paleYellow}>
      <LoadingView imageSrc={imageSrc}>{children}</LoadingView>
    </Modal>
  )
}
